import { Component, Input, Output, EventEmitter, OnDestroy, ViewEncapsulation, ViewChild, OnChanges } from '@angular/core';
import { firstValueFrom, Subject } from 'rxjs';
import { ERROR_IMAGE_LINK } from 'src/app/domain/cabinet/component/cabinet/cabinet.component';
import { OrganizationBackendService } from 'src/app/domain/organization/service/organization-backend.service';
import { Organization } from 'src/app/domain/organization/dto/Organization';
import { UploadComponent } from 'src/app/domain/shared/component/upload/upload.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-modal-organization-update',
  templateUrl: './modal-organization-update.component.html',
  styleUrls: ['./modal-organization-update.component.scss'],
  providers: [],
  encapsulation: ViewEncapsulation.Emulated,
})


export class ModalOrganizationUpdateComponent implements OnDestroy, OnChanges {
  private _destroyStream: Subject<void> = new Subject<void>();

  @Input() updatedOrganization: Organization;

  @Output() updatedOrg = new EventEmitter<Organization>();
  @ViewChild('upload') uploadComponent: UploadComponent;
  orgForm: FormGroup;
  modalButtons = {
    dismiss: 'Cancel',
    apply: 'Apply',
  };

  errorImageLink = ERROR_IMAGE_LINK;

  constructor(
    private formBuilder: FormBuilder,
    private orgService: OrganizationBackendService,
  ) { }


  ngOnDestroy(): void {
    this._destroyStream.next();
    this._destroyStream.complete();
  }

  ngOnChanges(): void {
    this.createForm(this.updatedOrganization);
  }

  async confirm(): Promise<void> {
    const awsImageName = await this.uploadComponent.upload('orgLogos', this.generateName());
    if (awsImageName) {
      this.orgForm.patchValue({ logo: awsImageName });
    }
    this.updatedOrg.emit(
      await firstValueFrom(
        this.orgService.updateMainInfo(this.orgForm.getRawValue()),
      ),
    );
  }

  close(): void {
    this.updatedOrg.emit(null);
    this.ngOnDestroy();
  }

  private generateName(): string {
    if (this.updatedOrganization.id) {
      const text = this.updatedOrganization.id;
      return text + '.jpeg';
    }
    return 'error.jpeg';
  }

  private createForm(organization: Organization): void {
    this.orgForm = this.formBuilder.group({
      uuid: new FormControl(organization.uuid),
      organizationId: new FormControl({ value: organization.organizationId, disabled: true }),
      id: new FormControl({ value: organization.id, disabled: true }),
      logo: new FormControl(organization.logo),
      name: new FormControl(organization.name, { validators: [Validators.required] }),
      website: new FormControl(organization.webSiteLink),
      linkedIn: new FormControl(organization.linkedIn),
      address: new FormControl(organization.address),
    });
  }
}

export class OrganizationUpdateDTO {
  uuid: string;
  id: number;
  logo: string;
  name: string;
  website: string;
  linkedIn: string;
  address: string;
}
